import React from 'react';
import { getProfileField } from '../translations/profileTranslation';

function Appoinetement({ ApointementContent, LanguageSelected, t, img ,divstyle ,ProfileContent}) {
    return (
        <div>
            {ApointementContent != '' && ApointementContent.length > 0 && (
                <div className={`pt-5 pb-7 pl-3 pr-3   relative ${divstyle} w-full`}>
                    <div className="pb-2">
                        <h1
                            className={`${LanguageSelected === 'ar'
                                    ? 'title title--h1 first-title title__separate text-theme right-2'
                                    : 'title left-2 title--h1 first-title title__separate text-theme'
                                }`}
                        >
                            {t("Prise de rendez-vous")}
                        </h1>
                    </div>

                    <div className="">
                        <div className="flex justify-between  items-center">
                            <div className="flex items-center gap-2">
                            <div className='ml-2 flex items-center justify-center bg-white p-1 rounded h-14 w-24 mr-2  rounded-lg'>
                                    <img src={img} className="w-16 w-16" alt="" />
                                </div>
                                <div className="text-about space-y-2">
                                {t("Cliquez ici pour prendre rendez-vous avec moi ")} {getProfileField(ProfileContent[0], 'first_name', LanguageSelected)}
                                </div>
                            </div>
                            <div>
                                {LanguageSelected == "ar" ?
                                    (
                                        <a href={ApointementContent[0]?.link_calendly} target='_blank'>

                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                                            </svg>


                                        </a>
                                    )
                                    :
                                    (
                                        <a href={ApointementContent[0]?.link_calendly} target='_blank'>

                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                            </svg>


                                        </a>
                                    )



                                }
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Appoinetement;
